// @ts-check
import './plot-number-tooltip.css';
import { h } from 'preact';

import StatusLabel from '../../../StatusLabel';

/**
 * @param {import('../../../../types').PlotNumber} props
 */
export default function PlotNumberTooltip({
	id,
	name,
	status
}) {
	return (
		<p data-id={id} className="plot-number-tooltip">
			<strong>{name}</strong><br />
			<strong><StatusLabel status={status} /></strong>
		</p>
	);
}
